import type { EvolutionDashboardResponse } from '@/api';

const getContratStatut = (data: EvolutionDashboardResponse): { status: string; prospectKey: string } => {
  const enCours = data?.listContrat?.enCours?.length ?? 0;
  const enTraitement = data?.listContrat?.enTraitement?.length ?? 0;

  if (enCours === 0 && enTraitement === 0) {
    return { status: 'sans contrat', prospectKey: 'dashboard.prospectSansContrat' };
  }
  if (enTraitement > 0 && enCours === 0) {
    return { status: 'info indispo', prospectKey: 'dashboard.prospectEnTraitement' };
  }
  if (enTraitement > 0) {
    return { status: '1er contrat en cours', prospectKey: '' };
  }
  return { status: 'Avec contrat', prospectKey: '' };
};

export { getContratStatut };
